module.exports = __webpack_public_path__ + "img/NO914864445.d4dbf752.svg";